<template>
  <div class="relative w-full h-24 overflow-hidden bg-white shadow-md">
    <div
      class="flex gap-x-16 animate-scroll whitespace-nowrap"
      :style="{ width: `${images.length * 2 * imageWidth}px` }"
    >
      <div
        v-for="(image, index) in [...images, ...images]"
        :key="index"
        class="h-24 flex-shrink-0 flex justify-center items-center"
        :style="{ width: `${imageWidth}px` }"
      >
        <img
          :src="image"
          :alt="'Slide ' + index"
          class="max-h-16 w-full object-contain"
          height="64"
          width="180"
          loading="lazy"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
const images = [
  "/logos/product-logo-e4education.svg",
  "/logos/product-logo-horizons.webp",
  "/logos/product-logo-primarysite.webp",
  "/logos/product-logo-sisra-analytics.webp",
  "/logos/product-logo-sonar-awards.svg",
  "/logos/product-logo-sonar-curriculum.webp",
  "/logos/product-logo-sonar-tracker.svg",
];

const imageWidth = 250;
</script>

<style scoped>
@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-1750px);
  }
}

.animate-scroll {
  animation: scroll 40s linear infinite;
}
</style>
